<template>
    <Dialog :value="showDialog" @input="$listeners.input" :title="'Atenção'" width="600">
        <p>
            A consulta selecionada foi atribuída como "{{ consulta.situacao }}" pelo Sistema de Crédito. Deseja realmente alterar o status de autorização para <strong>"Pendente" e solicitar o ajuste ou defesa dos dados para o parceiro</strong>?<br>
            <span>Será necessário indicar <strong>ao menos um dado</strong> que deverá ser ajustado ou defendido<strong>*</strong></span><br>
            <span>O motivo digitado será exibido <strong>ao parceiro comercial!*</strong></span>
        </p>
        <v-form ref="form" class="pt-4" @submit.prevent="confirmar">
            <m-text-field ref="input"
                          label="Motivo:"
                          hint="O motivo digitado será exibido ao usuário vendedor parceiro!"
                          class="required"
                          type="text"
                          v-model="motivo"
                          placeholder="Descreva o motivo da troca do status de autorização"
                          :rules="[$rules.required]"
                          maxlength="800"
                          outlined>
            </m-text-field>
            <div>
                <p>Qual informação deverá ser ajustada?*</p>
                <div class="checkbox-container">
                    <v-checkbox
                            v-for="campo in camposPendencia"
                            :key="campo.value"
                            v-model="dadosSelecionados"
                            :label="campo.label"
                            :value="campo.value"
                            class="checkbox-item"
                            color="secondary"
                            hide-details
                    />
                </div>
                <div v-if="checkboxError" class="error--text mt-2">
                    Selecione ao menos um item
                </div>
            </div>
        </v-form>
        <v-layout class="justify-end">
            <v-btn color="secondary" class="mt-5 mr-4" @click="fechar()">Fechar</v-btn>
            <v-btn id="ButtonFinalizar" class="mt-5" color="primary" @click="confirmar()">
                Confirmar
            </v-btn>
        </v-layout>
    </Dialog>
</template>

<script>
  import { CreditasAvaliationStatus } from '../../../../plugins/constants'

  export default {
    name: 'DialogPendenciarDados',
    props: {
      value: Boolean,
      consulta: Object,
      statusAvaliacaoCredita: String
    },
    data () {
      return {
        motivo: '',
        dadosSelecionados: [],
        checkboxError: false
      }
    },
    computed: {
      showDialog: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      camposPendencia () {
        if (!this.consulta || !this.consulta.pessoa) return []
        // fisica
        if (this.consulta.pessoa === 'fisica') {
          return [
            { label: 'Nome', value: 'pendencia_nome' },
            { label: 'Data de nascimento', value: 'pendencia_data_nascimento' },
            { label: 'E-mail', value: 'pendencia_email' }
          ]
        }
        // jurídica
        return [
          { label: 'Razão social', value: 'pendencia_razao_social' },
          { label: 'Data de fundação', value: 'pendencia_dt_fundacao' },
          { label: 'E-mail', value: 'pendencia_email' }
        ]
      },
      CreditasAvaliationStatus: () => CreditasAvaliationStatus
    },
    watch: {
      showDialog () {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
        this.checkboxError = false
        this.motivo = ''
        this.dadosSelecionados = []
      }
    },
    methods: {
      fechar () {
        this.motivo = ''
        this.dadosSelecionados = []
        this.checkboxError = false
        if (this.$refs.form) this.$refs.form.resetValidation()
        this.showDialog = false
      },
      confirmar () {
        const formValido = this.$refs.form.validate()
        this.checkboxError = this.dadosSelecionados.length === 0
        if (!formValido || this.checkboxError) return

        this.$emit('confirmar', {
          motivo: this.motivo,
          dadosSelecionados: this.dadosSelecionados,
          statusAvaliacaoCredita: this.statusAvaliacaoCredita
        })
        this.reload()
      },
      reload () {
        this.$refs.form.resetValidation()
        this.$emit('reload')
        this.fechar()
        return true
      }
    }
  }
</script>

<style scoped>
.checkbox-container {
  display: flex;
  flex-direction: column;
}

.checkbox-item {
  margin-bottom: -5px !important; /* Reduz o espaço entre os checkboxes */
}
</style>
